export default __webpack_public_path__ + "static/media/moon.64ec3a4c.gif";